import { gql } from '@apollo/client'

export const SET_CUSTOMER_SQUARE_CARD_AS_PRIMARY = gql`
  mutation SetCustomerSquareCardAsPrimary($input: SetCustomerSquareCardAsPrimaryInput!) {
    setAsPrimaryCustomerSquareCard(input: $input) {
      customerSquareCard {
        id
        primary
      }
    }
  }
`
